import { DATABASE_TYPES, STORAGE_TYPES } from './database';

const DBAAS = {
  USD: {
    [DATABASE_TYPES.MONGODB]: {
      core: {
        PER_HOUR: 0.066,
      },
      ram: {
        PER_HOUR: 0.0388,
      },
      storage: {
        [STORAGE_TYPES.SSD_PREMIUM]: {
          PER_MONTH: 0.17,
        },
        [STORAGE_TYPES.SSD_STANDARD]: {
          PER_MONTH: 0.08,
        },
        [STORAGE_TYPES.HDD]: {
          PER_MONTH: 0.0533,
        },
      },
    },
    [DATABASE_TYPES.POSTGRES]: {
      core: {
        PER_HOUR: 0.072,
      },
      ram: {
        PER_HOUR: 0.0084,
      },
      storage: {
        [STORAGE_TYPES.SSD_PREMIUM]: {
          PER_MONTH: 0.17,
        },
        [STORAGE_TYPES.SSD_STANDARD]: {
          PER_MONTH: 0.08,
        },
        [STORAGE_TYPES.HDD]: {
          PER_MONTH: 0.0533,
        },
      },
    },
  },
  EUR: {
    [DATABASE_TYPES.MONGODB]: {
      core: {
        PER_HOUR: 0.06,
      },
      ram: {
        PER_HOUR: 0.0353,
      },
      storage: {
        [STORAGE_TYPES.SSD_PREMIUM]: {
          PER_MONTH: 0.15,
        },
        [STORAGE_TYPES.SSD_STANDARD]: {
          PER_MONTH: 0.07,
        },
        [STORAGE_TYPES.HDD]: {
          PER_MONTH: 0.04,
        },
      },
    },
    [DATABASE_TYPES.POSTGRES]: {
      core: {
        PER_HOUR: 0.06,
      },
      ram: {
        PER_HOUR: 0.007,
      },
      storage: {
        [STORAGE_TYPES.SSD_PREMIUM]: {
          PER_MONTH: 0.15,
        },
        [STORAGE_TYPES.SSD_STANDARD]: {
          PER_MONTH: 0.07,
        },
        [STORAGE_TYPES.HDD]: {
          PER_MONTH: 0.04,
        },
      },
    },
  },
  GBP: {
    [DATABASE_TYPES.MONGODB]: {
      core: {
        PER_HOUR: 0.054,
      },
      ram: {
        PER_HOUR: 0.0318,
      },
      storage: {
        [STORAGE_TYPES.SSD_PREMIUM]: {
          PER_MONTH: 0.14,
        },
        [STORAGE_TYPES.SSD_STANDARD]: {
          PER_MONTH: 0.063,
        },
        [STORAGE_TYPES.HDD]: {
          PER_MONTH: 0.04,
        },
      },
    },
    [DATABASE_TYPES.POSTGRES]: {
      core: {
        PER_HOUR: 0.06,
      },
      ram: {
        PER_HOUR: 0.007,
      },
      storage: {
        [STORAGE_TYPES.SSD_PREMIUM]: {
          PER_MONTH: 0.14,
        },
        [STORAGE_TYPES.SSD_STANDARD]: {
          PER_MONTH: 0.063,
        },
        [STORAGE_TYPES.HDD]: {
          PER_MONTH: 0.04,
        },
      },
    },
  },
  CAD: {
    [DATABASE_TYPES.MONGODB]: {
      core: {
        PER_HOUR: 0.078,
      },
      ram: {
        PER_HOUR: 0.0459,
      },
      storage: {
        [STORAGE_TYPES.SSD_PREMIUM]: {
          PER_MONTH: 0.23,
        },
        [STORAGE_TYPES.SSD_STANDARD]: {
          PER_MONTH: 0.11,
        },
        [STORAGE_TYPES.HDD]: {
          PER_MONTH: 0.0533,
        },
      },
    },
    [DATABASE_TYPES.POSTGRES]: {
      core: {
        PER_HOUR: 0.072,
      },
      ram: {
        PER_HOUR: 0.0084,
      },
      storage: {
        [STORAGE_TYPES.SSD_PREMIUM]: {
          PER_MONTH: 0.23,
        },
        [STORAGE_TYPES.SSD_STANDARD]: {
          PER_MONTH: 0.11,
        },
        [STORAGE_TYPES.HDD]: {
          PER_MONTH: 0.0533,
        },
      },
    },
  },
  MXN: {
    [DATABASE_TYPES.MONGODB]: {
      core: {
        PER_HOUR: 1.188,
      },
      ram: {
        PER_HOUR: 0.6989,
      },
      storage: {
        [STORAGE_TYPES.SSD_PREMIUM]: {
          PER_MONTH: 3.135,
        },
        [STORAGE_TYPES.SSD_STANDARD]: {
          PER_MONTH: 1.463,
        },
        [STORAGE_TYPES.HDD]: {
          PER_MONTH: 1.093,
        },
      },
    },
    [DATABASE_TYPES.POSTGRES]: {
      core: {
        PER_HOUR: 1.476,
      },
      ram: {
        PER_HOUR: 0.1722,
      },
      storage: {
        [STORAGE_TYPES.SSD_PREMIUM]: {
          PER_MONTH: 3.135,
        },
        [STORAGE_TYPES.SSD_STANDARD]: {
          PER_MONTH: 1.463,
        },
        [STORAGE_TYPES.HDD]: {
          PER_MONTH: 1.093,
        },
      },
    },
  },
};

const TEMPLATE_PRICES = {
  [DATABASE_TYPES.MONGODB]: {
    '3a199f09-9699-4493-a858-82d9f55a382e': {
      // name: 'MongoDB Business 4XL',
      USD: {
        PER_HOUR: 2.724,
        PER_MONTH: 1962.0,
      },
      EUR: {
        PER_HOUR: 2.27,
        PER_MONTH: 1635.0,
      },
      GBP: {
        PER_HOUR: 2.27,
        PER_MONTH: 1635.0,
      },
      CAD: {
        PER_HOUR: 2.724,
        PER_MONTH: 1962.0,
      },
      MXN: {
        PER_HOUR: 55.842,
        PER_MONTH: 40221.0,
      },
    },
    '609f3099-ff0d-456a-8ac7-4dd379a6ee14': {
      // name: 'MongoDB Business L',
      USD: {
        PER_HOUR: 0.336,
        PER_MONTH: 242.4,
      },
      EUR: {
        PER_HOUR: 0.28,
        PER_MONTH: 202.0,
      },
      GBP: {
        PER_HOUR: 0.280,
        PER_MONTH: 202.0,
      },
      CAD: {
        PER_HOUR: 0.336,
        PER_MONTH: 242.4,
      },
      MXN: {
        PER_HOUR: 6.888,
        PER_MONTH: 4969.2,
      },
    },
    '8c2c51c7-f1f8-4f44-bf3e-6e5cc8e50f07': {
      // name: 'MongoDB Business M',
      USD: {
        PER_HOUR: 0.168,
        PER_MONTH: 121.2,
      },
      EUR: {
        PER_HOUR: 0.14,
        PER_MONTH: 101.0,
      },
      GBP: {
        PER_HOUR: 0.140,
        PER_MONTH: 101.0,
      },
      CAD: {
        PER_HOUR: 0.168,
        PER_MONTH: 121.2,
      },
      MXN: {
        PER_HOUR: 3.444,
        PER_MONTH: 2484.6,
      },
    },
    'd5d6aa0a-6db0-4440-a5ac-00cd42b00bb3': {
      // name: 'MongoDB Business S',
      USD: {
        PER_HOUR: 0.084,
        PER_MONTH: 61.2,
      },
      EUR: {
        PER_HOUR: 0.07,
        PER_MONTH: 51.0,
      },
      GBP: {
        PER_HOUR: 0.070,
        PER_MONTH: 51.0,
      },
      CAD: {
        PER_HOUR: 0.084,
        PER_MONTH: 61.2,
      },
      MXN: {
        PER_HOUR: 1.722,
        PER_MONTH: 1254.6,
      },
    },
    '7f646ba1-a739-485f-b5f6-1039958553d5': {
      // name: 'MongoDB Business XL',
      USD: {
        PER_HOUR: 0.672,
        PER_MONTH: 484.8,
      },
      EUR: {
        PER_HOUR: 0.56,
        PER_MONTH: 404.0,
      },
      GBP: {
        PER_HOUR: 0.560,
        PER_MONTH: 404.0,
      },
      CAD: {
        PER_HOUR: 0.672,
        PER_MONTH: 484.8,
      },
      MXN: {
        PER_HOUR: 13.776,
        PER_MONTH: 9938.4,
      },
    },
    '6b78ea06-ee0e-4689-998c-fc9c46e781f6': {
      // name: 'MongoDB Business XS',
      USD: {
        PER_HOUR: 0.042,
        PER_MONTH: 31.2,
      },
      EUR: {
        PER_HOUR: 0.035,
        PER_MONTH: 26.0,
      },
      GBP: {
        PER_HOUR: 0.035,
        PER_MONTH: 26.0,
      },
      CAD: {
        PER_HOUR: 0.042,
        PER_MONTH: 31.2,
      },
      MXN: {
        PER_HOUR: 0.861,
        PER_MONTH: 639.6,
      },
    },
    '14d23a55-22d6-46f9-b884-2f864f3fda0f': {
      // name: 'MongoDB Business XXL',
      USD: {
        PER_HOUR: 1.356,
        PER_MONTH: 976.8,
      },
      EUR: {
        PER_HOUR: 1.13,
        PER_MONTH: 814.0,
      },
      GBP: {
        PER_HOUR: 1.130,
        PER_MONTH: 814.0,
      },
      CAD: {
        PER_HOUR: 1.356,
        PER_MONTH: 976.8,
      },
      MXN: {
        PER_HOUR: 27.798,
        PER_MONTH: 20024.4,
      },
    },
    '33457e53-1f8b-4ed2-8a12-2d42355aa759': {
      // name: 'MongoDB Playground',
      USD: {
        PER_HOUR: 0.042,
        PER_MONTH: 31.2,
      },
      EUR: {
        PER_HOUR: 0.035,
        PER_MONTH: 26.0,
      },
      GBP: {
        PER_HOUR: 0.035,
        PER_MONTH: 26.0,
      },
      CAD: {
        PER_HOUR: 0.042,
        PER_MONTH: 31.2,
      },
      MXN: {
        PER_HOUR: 0.861,
        PER_MONTH: 639.6,
      },
    },
  },
};

export const MONTH_HOUR_MULTIPLIER = 720;
export const PRICE_CATEGORIES = {
  DATABASE: DBAAS,
  TEMPLATE_PRICES,
};
